import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getAllAnswers = () =>
  apiClient.get(REST_API_BASE_URL + '/answers');

export const saveAnswer = (subscriptionid, questionid, answer) =>
  apiClient.post(
    `${REST_API_BASE_URL}/subscription/${subscriptionid}/question/${questionid}/answer`,
    answer,
  );

export const getAnswer = (subscriptionid, answerid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/${subscriptionid}/answer/${answerid}`,
  );

export const updateAnswer = (id, answer) =>
  apiClient.put(`${REST_API_BASE_URL}/answer/${id}`, answer);

export const deleteAnswer = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/answer/${id}`);

export default apiClient;
